import { InfoField } from '@occc/ui-design-system';

import {
  arrangeNodeGroups,
  renderNodeGroups,
} from '@occc-app/routes/CampaignComponents/component-details/sections/utils';
import { SectionCard } from '../../components';

type EngagementSectionProps = {
  availableMessage?: string | null;
  fulfillmentMessage?: string | null;
};

export const EngagementSection = ({
  availableMessage,
  fulfillmentMessage,
}: EngagementSectionProps) => {
  const blockGroups = arrangeNodeGroups(
    [
      availableMessage && <InfoField label='Offer Available Message' value={availableMessage} />,
      fulfillmentMessage && (
        <InfoField label='Offer Fulfillment Message' value={fulfillmentMessage} />
      ),
    ],
    2,
  );

  return blockGroups.length ? (
    <SectionCard title='Engagement'>{renderNodeGroups(blockGroups, 2)}</SectionCard>
  ) : null;
};
